import {
  Button,
  CircularProgress,
  Divider,
  Grid,
  IconButton,
  InputAdornment,
  makeStyles,
  Theme,
  Typography,
  useMediaQuery,
} from "@material-ui/core";
import firebase from "firebase";
import _ from "lodash";
import * as React from "react";
import { useCallback, useEffect, useState } from "react";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import VisibilityIcon from "@material-ui/icons/Visibility";

import { CustomTheme } from "../../../../types/customTheme";
import TextfieldCommon from "../../../../components/textField/TextfieldCommon";
import { useForm } from "react-hook-form";
import ButtonCommon from "../../../../components/buttons/ButtonCommon";
import TextfieldDefault from "../../../../components/textField/TextfieldDefault";
import RegistrationPage from "./RegistrationPage";
import LoginPage from "./LoginPage";
import PasswordResetModal from "./PasswordResetModal";
import DefaultAlert from "../../../../components/alerts/DefaultAlert";

const useStyles = makeStyles((theme: CustomTheme) => ({
  ContentContainerWrapper: {
    display: "flex",
    alignItems: "center",
    height: "100vh",
    // flex: 1,
    // marginBottom: (props) => (props.isOrderStatusPage ? 0 : 16),
    // [theme.breakpoints.down("xs")]: {
    //   height: 1200,
    //   maxHeight: 56,
    // },
    // [theme.breakpoints.up("md")]: {
    //   minHeight: 500,
    // },
    overflowY: "auto",
    overflowX: "hidden",
    // overflowY: (props) => (props.overFlowUnset ? "unset" : "auto"),
    // overflowX: (props) => (props.overFlowUnset ? "unset" : "hidden"),
  },
  makeMiddle: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: theme.palette.background.paper,
    padding: "12px",
    // marginTop: "300px"
  },
}));

export interface ManageAppsProps {}

/* Get all location information using API call at initial load. */
const SignInPage: React.FunctionComponent<ManageAppsProps> = () => {
  const [customer, setCustomer] = useState({
    email: "",
    password: "",
  });
  const [error, setError] = useState("");
  const [alertMessage, setAlertMessage] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isOpenPasswordResetNodal, setIsOpenPasswordResetNodal] =
    useState(false);
  const [isLoginOrRegister, setIsLoginOrRegister] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [
    isOpenEmailVerificationLoadingModal,
    setIsOpenEmailVerificationLoadingModal,
  ] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);

  const { register, errors, trigger } = useForm();

  const handleChange = (e: any) => {
    const { value } = e.target;
    setCustomer(value);
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleOpenPasswordResetModal = () => {
    setIsOpenPasswordResetNodal(true);
  };

  const handleContinue = () => {};

  const handleChangeLoginStatus = () => {
    setIsLoginOrRegister(!isLoginOrRegister);
  };

  const classes = useStyles();

  return (
    <>
      {isLoginOrRegister && (
        <LoginPage
          handleChangeLoginStatus={handleChangeLoginStatus}
          handleOpenPasswordResetModal={handleOpenPasswordResetModal}
          isLoginOrRegister={isLoginOrRegister}
          setAuthError={setError}
        />
      )}
      {!isLoginOrRegister && (
        <RegistrationPage
          handleChangeLoginStatus={handleChangeLoginStatus}
          isLoginOrRegister={isLoginOrRegister}
          setAuthError={setError}
        />
      )}
      <PasswordResetModal
        isLoading={isLoading}
        setOpenDialog={setIsOpenPasswordResetNodal}
        openDialog={isOpenPasswordResetNodal}
        setIsLoading={setIsLoading}
        setAlertMessage={setAlertMessage}
        setError={setError}
      />

      <DefaultAlert
        open={!!error}
        handleClose={() => setError("")}
        message={error}
        severity="error"
      />

      <DefaultAlert
        open={!!alertMessage}
        handleClose={() => setAlertMessage("")}
        message={alertMessage}
        severity="success"
      />
    </>
  );
};

export default SignInPage;
